module.exports = __webpack_public_path__ + "img/stock3.a9616f28.png";